export default {
  getCount: state => state.count,
  getCountApplicationsIncomplete: state => state.countApplicationsInomplete,
  getPersonalityTestNotification: state => state.personalityNotification,
  getSuggestedNotifications: state => state.suggestedNotifications,
  getRedeemTransactions: state => state.redeemTransactions,
  getUserRedeem: state => state.userRedeem,
  getApplicationsLoaded: state => state.applicationsLoaded
}
